import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Alert, Form, Modal } from "antd";
import axios from "axios";
import { axiosErrorHandler, isConcurrentModificationError } from "../../../../swzutils";
import ConsignmentRequirementsFormItems from "./ConsignmentRequirementsFormItems";
const ConsignmentRequirementsModal = (props) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    useEffect(() => {
        // Clear previous error messages
        setErrorMessage(null);
    }, [props.consignment]);
    const patchDelivery = (formValues) => {
        setLoading(true);
        axios.patch(`/admin/v1/consignments/${props.consignment.id}`, {
            version: props.consignment.version,
            pickUpPhotoRequired: formValues.pickUpPhotoRequired,
            completionPhotoRequired: formValues.completionPhotoRequired,
            completionSignatureRequired: formValues.completionSignatureRequired,
            specialRequirements: (formValues.specialRequirements || []).map((id) => {
                return { id: parseInt(id) };
            })
        }).then(response => {
            props.onUpdated(response.data);
        }).catch(error => {
            if (isConcurrentModificationError(error)) {
                setErrorMessage("The delivery date could not be updated. This is because another user has updated the same consignment.  Please refresh the consignment list and try again.");
            }
            else {
                axiosErrorHandler(error, setErrorMessage);
            }
        }).finally(() => setLoading(false));
    };
    return (_jsxs(Modal, { title: "Update Delivery Requirements", open: props.open, okText: "Update", onOk: form.submit, onCancel: () => {
            setErrorMessage(null);
            props.onCancel();
        }, confirmLoading: loading, destroyOnHidden: true, children: [_jsx(Form, { form: form, onFinish: patchDelivery, layout: "vertical", initialValues: {
                    'pickUpPhotoRequired': props.consignment.pickUpPhotoRequired,
                    'completionPhotoRequired': props.consignment.completionPhotoRequired,
                    'completionSignatureRequired': props.consignment.completionSignatureRequired,
                    'specialRequirements': props.consignment.specialRequirements || []
                }, children: _jsx(ConsignmentRequirementsFormItems, { tenantId: props.consignment.tenantId, onSpecialRequirementOptionsLoaded: (specialRequirementOptions) => {
                        form.setFieldsValue({
                            specialRequirements: (props.consignment.specialRequirements || []).map(it => it.id)
                        });
                    } }) }), errorMessage &&
                _jsx("div", { style: { marginTop: "20px" }, children: _jsx(Alert, { type: "error", title: errorMessage, banner: true }) })] }));
};
export default ConsignmentRequirementsModal;
